module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-10-2226cae8a5738b8dadf2fc5c17bdf54e.jpg";